import { UserBoard } from './components/UserBoard';
import { ProfileForm } from './components/ProfileForm';
import { EmployeeComposed } from '@/api/apis/resources';

type ProfileProps = {
  data: EmployeeComposed;
  isReadOnly: boolean;
};

export const Profile = ({ data, isReadOnly }: ProfileProps) => {
  return (
    <div className="flex flex-row w-full">
      <ProfileForm data={data} isReadOnly={isReadOnly} />
      <UserBoard data={data} isReadOnly={isReadOnly} />
    </div>
  );
};
